import { Link } from 'react-router-dom';
import type { SavedItem } from '../../../context/CartContext';
import { getDefaultReleaseCover, getImageVariant } from '../../../lib/media';

const FALLBACK_COVER = getDefaultReleaseCover('small');

interface SavedForLaterProps {
  items: SavedItem[];
  onMoveToCart: (id: string) => void;
  onRemove: (id: string) => void;
}

export const SavedForLater = ({ items, onMoveToCart, onRemove }: SavedForLaterProps) => {
  if (items.length === 0) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mt-6">
      <h3 className="font-semibold text-gray-900 mb-4">
        Saved for Later ({items.length})
      </h3>
      
          <div className="space-y-3">
            {items.map((item) => {
              const coverSrc =
                (getImageVariant(item.cover, 'small') ?? item.cover)?.trim() || FALLBACK_COVER;
              return (
              <div key={item.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                <img
                  src={coverSrc}
                  alt={`${item.title} cover`}
                  className="w-12 h-12 rounded object-cover object-top flex-shrink-0"
                />
                
                <div className="flex-1 min-w-0">
                  <h4 className="font-medium text-gray-900 truncate">{item.title}</h4>
                  {item.kind === 'track' && (
                    <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-800">
                      Track
                    </span>
                  )}
                  {item.kind === 'track' && item.releaseTitle && (
                    <p className="text-xs text-gray-500">
                      From{' '}
                      {item.releaseSlug ? (
                        <Link
                          to={`/releases/${item.releaseSlug}`}
                          className="font-semibold text-emerald-600 hover:text-emerald-700"
                        >
                          {item.releaseTitle}
                        </Link>
                      ) : (
                        <span className="font-semibold">{item.releaseTitle}</span>
                      )}
                    </p>
                  )}
                  <Link 
                    to={`/artists/${item.artistSlug}`}
                    className="text-sm text-emerald-600 hover:text-emerald-700 transition-colors"
                  >
                    {item.artist}
                  </Link>
                  <p className="text-sm text-gray-600">KES {item.price.toLocaleString()}</p>
                </div>
            
            <div className="flex items-center gap-2">
              <button
                onClick={() => onMoveToCart(item.id)}
                className="px-3 py-1 bg-emerald-600 text-white rounded text-sm font-medium hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Move to cart
              </button>
              <button
                onClick={() => onRemove(item.id)}
                className="p-1 text-gray-400 hover:text-red-600 transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-close-line"></i>
                </div>
              </button>
            </div>
          </div>
        );
        })}
      </div>
    </div>
  );
};
